import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useModules } from '../contexts/ModuleContext'
import DataState from './ui/DataState'

/**
 * ProtectedRoute — Guards a route based on module visibility (RBAC + extra_modules whitelist).
 * If user is not authorized for this specific module, redirects to dashboard or shows error.
 *
 * Оба экрана — проверку полномочий и отказ — рисует общий `DataState`. До
 * волны 2 отказ был собран здесь вручную: заголовок красным, кнопка `btn--sm`
 * ниже 44px и `window.location.href` вместо перехода роутером (полная
 * перезагрузка приложения ради ссылки на главную). Экран «нет прав» —
 * единственный на весь ERP, поэтому он же обязан быть эталонным.
 */
export default function ProtectedRoute({ moduleKey, children }) {
    const { user, loading: authLoading } = useAuth()
    const { isModuleVisible, loading: modulesLoading } = useModules()

    if (authLoading || modulesLoading) {
        return <DataState kind="loading" title="Проверяем полномочия…" rows={3} />
    }

    // Unkeyed routes (no module restriction) always pass through
    if (moduleKey === '' || moduleKey === 'dashboard') {
        return children
    }

    // All visibility rules (WHITELIST_CORE, RBAC, extra_modules) live in ModuleContext
    if (!isModuleVisible(moduleKey, user)) {
        console.warn(`[ProtectedRoute] Access denied to module: ${moduleKey} for user: ${user?.login}`)
        return (
            <DataState
                kind="forbidden"
                hint="Раздел открыт не для всех ролей. Доступ выдаёт администратор Onboardix."
                detail={`Раздел: ${moduleKey}`}
                action={<Link to="/" className="btn btn--secondary">Вернуться на главную</Link>}
            />
        )
    }

    return children
}
